import { useRef, useState } from "react";
import { Image, Center, useToast, FormLabel, Text } from "@chakra-ui/react";
import { pillarCover } from "../../../assets/new-images/icons";

export default function CoverInput({
  pillarIndex,
  setValue,
  trigger,
  imageUrl,
  setImageUpdated,
}) {
  const toast = useToast();
  // const [progress, setProgress] = useState(0);
  const [isSending, setIsSending] = useState(false);
  const [uploadedImage, setUploadedImage] = useState(null);
  const fileInputRef = useRef(null);

  async function handleImageUpload(event) {
    if (!event.target.files?.length) {
      return;
    }
    const selectedFiles = event.target.files;
    const file = selectedFiles[0];

    const fileType = file.type.split("/")[1];

    const reader = new FileReader();

    reader.readAsDataURL(file);
    const base64Promise = new Promise((resolve) => {
      reader.onload = function () {
        const base64 = reader.result?.split(",")[1];
        resolve(base64);
      };
    });

    const base64 = await base64Promise;

    setValue(`form.${pillarIndex}.pillarImage`, base64);
    trigger(`form.${pillarIndex}.pillarImage`);

    const imageURL = `data:image/${fileType};base64,${base64}`;
    setUploadedImage(imageURL);
    setImageUpdated && setImageUpdated(true);
  }

  return (
    <Center
      bg="rgba(92, 96, 102, 0.1)"
      w="264px"
      minW="264px"
      maxW="264px"
      h="176px"
      borderRadius="8px"
      flexDir="column"
      gap="8px"
      overflow="hidden"
    >
      <FormLabel
        // htmlFor={name}
        cursor={isSending ? "progress" : "pointer"}
        opacity={isSending ? 0.5 : 1}
        w="full"
        h="full"
        display="flex"
        alignItems="center"
        justifyContent="center"
        pos="relative"
        m={0}
      >
        {uploadedImage || imageUrl?.length ? (
          <Image
            src={uploadedImage ? uploadedImage : imageUrl}
            alt="cover"
            pos="absolute"
            width="full"
          />
        ) : (
          <Center flexDir="column">
            <Image src={pillarCover} alt="cover" mb="12px" />
            <Text as="span" fontSize="sm" lineHeight="17.36px" color="#5C6066">
              Imagem de capa
            </Text>
          </Center>
        )}

        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={handleImageUpload}
          accept=".jpg,.png,.svg"
        />
      </FormLabel>
    </Center>
  );
}
